import { render, staticRenderFns } from "./customerHotline.vue?vue&type=template&id=4eb5805b&scoped=true&"
import script from "./customerHotline.vue?vue&type=script&lang=js&"
export * from "./customerHotline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb5805b",
  null
  
)

export default component.exports